import './header.scss';

import enquire from 'enquire.js';
import { Responsive } from '../utils';

const COMPONENT_NAME = 'primary-header';

const BEM = {
  BLOCK: COMPONENT_NAME,
  BURGER_MOBILE_MENU_OPEN: 'custom-navbar-toggler',
  BURGER_MOBILE_MENU_CLOSE: 'close-menu',
  FIRST_SON_CLICK_IMG: 'btn-first-son-img',
  SECOND_SON_CLICK_IMG: 'btn-second-son-img',
};

/**
 * version    1.0
 * class      <type> (Header)
 * classdesc  Component that manage the page header
 */
export class Header {
  constructor() {
    this._findUIElements();
    this._bindEvents();
  }

  // private methods

  _findUIElements() {
    this._els = {
      burgerMobileMenuOpen: $(`.${BEM.BURGER_MOBILE_MENU_OPEN}`),
      burgerMobileMenuClose: $(`.${BEM.BURGER_MOBILE_MENU_CLOSE}`),
      firstSonBtnImg: $(`.${BEM.FIRST_SON_CLICK_IMG}`),
      secondSonBtnImg: $(`.${BEM.SECOND_SON_CLICK_IMG}`),
      searchButton: $('.nav-search .dropdown-toggle'),
    };
  }

  _bindEvents() {
    const self = this;

    enquire.register(`${Responsive.getBreakpointMaxMediaQuery('md')}`, () => {
      self._openMobileMenu();
      self._closeMobileMenu();
      self._closeMobileMenuOnSearch();
    });

    self._changeMenuImg();
  }

  _changeMenuImg() {
    let imgToShow = '';

    $('[data-title]').on('click', function () {
      imgToShow = $(this).data('title');

      if ($('.internal-box--visible').length > 0) {
        $('.internal-box--visible').removeClass('internal-box--visible');
      }

      $(`[data-argument=${imgToShow}]`).addClass('internal-box--visible');
    });
  }

  _openMobileMenu() {
    this._els.burgerMobileMenuOpen.on('click', () => {
      $('body').addClass('opened-menu-mobile');
    });
  }

  _closeMobileMenu() {
    this._els.burgerMobileMenuClose.on('click', () => {
      $('body').removeClass('opened-menu-mobile');
    });
  }

  _closeMobileMenuOnSearch() {
    this._els.searchButton.on('click', () => {
      $('body').removeClass('opened-menu-mobile');

      $('.custom-navbar-toggler').attr('aria-expanded', 'false');

      $('#navC1')
        .removeClass('show')
        .css('display', '');
    });
  }
}
